import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import SDK from 'utils/sdk';

const SdkLoader = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    async function init() {
      await SDK.init();
      setReady(true);
    }
    init();
  }, []);

  if (!ready) return null;

  return children;
};

SdkLoader.propTypes = {
  token: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default SdkLoader;
